import { Loader, Navigation, PageContainer } from '../components';
import React, { Fragment, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';

import { BugReportButton } from '../containers';
import Chords from './chords';
import ContactPage from './contact';
import Facts from './facts';
import Forbidden from '../components/forbidden';
import Library from './library';
import MidiPage from './midipage';
import MyLibrary from './mylibrary';
import NetworkError from '../components/networkerror';
import NotFound from '../components/notfound';
import PricingPage from './pricing';
import Profile from './profile';
import { Router } from '@reach/router';
import Scales from './scales';
import Snippets from './snippets';
import Song from './song';
import SongAdd from './song-add';
import SongEdit from './song-edit';
import Songs from './songs';
import StartPage from './startpage';
import StoreProvider from '../store';
import { getRoles } from '../auth/roles';
import { useAuth } from 'react-oidc-context';

const PrivateRoute = props => {
  const auth = useAuth();
  let { as: Cmp, roles, ...otherProps } = props;

  if (auth.isLoading) return <Loader />;
  // AuthErrorBanner (rendered in Pages()) shows the message; just stop the
  // signinRedirect loop here instead of retrying against a broken callback.
  if (auth.error) return null;
  if (!auth.isAuthenticated) {
    auth.signinRedirect({ state: { returnTo: window.location.pathname } });
    return <Loader />;
  }
  if (roles && !roles.some(role => getRoles(auth.user).includes(role))) {
    return <Forbidden />;
  }
  return <Cmp {...otherProps}></Cmp>;
};

const GET_ERROR= gql`
  query GetError {
    error @client
  }
`;
const ErrorHandler = ({ children }) => {
  const { data, load, err } = useQuery(GET_ERROR);
  if(load) return;
  console.log(data && data.error);
  return data && data.error
  ? (
    <Fragment>
      AN ERROR HAPPENED
      {data && data.error}
    </Fragment>
  )
  : children;
};

const AuthErrorBanner = () => {
  const auth = useAuth();
  if (!auth.error) return null;
  console.error('[auth error]', auth.error);
  return (
    <div className="notification is-danger">
      Inloggningen misslyckades: {auth.error.message}
    </div>
  );
};

export default function Pages() {
  useEffect(() => {

      const ele = document.getElementById('ipl-progress-indicator');
      if(ele){
        // fade out
        ele.classList.add('available')
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = ''
        }, 2000)    
      }
  }, []);
  return (
    <Fragment>

      {/* <GlobalStyles /> */}
      <StoreProvider>
      <Navigation/>
      <AuthErrorBanner/>
      <BugReportButton/>
      <div className="container">
                <div className="columns">
                <div className="column is-1"/>
                    <div className="column is-10 pagebg">
                        {/* <Breadcrumb/> */}
  {/*                       <Container>
                        <Columns overlay centered vCentered>
                          <Columns.Column narrow>
                            <Notification color="default">First Column</Notification>
                          </Columns.Column>
                        </Columns>
                        
                        </Container> */}

                        <PageContainer>
                        <Router primary={false} component={Fragment}>
                          
                            <StartPage path="/" />
                            <MidiPage path="/midipage" />
                            <Songs path="songs" />
                            <Song path="song/:slug" />
                              {/* <PrivateRoute as={Song} path="song/:slug" /> */}
                            <Facts path="facts" />
                              <Song path="fact/:slug" />
                            <PrivateRoute as={MyLibrary} path="/mylibrary" />
                            <ContactPage path="/contact" />
                            <PricingPage path="/pricing" />
                            <PrivateRoute as={Profile} path="/profile" />

                            <PrivateRoute as={Library} path="library" roles={['admin']} />
                            <Chords path="chords" />
                            <Scales path="scales" />
                            <PrivateRoute as={Snippets} path="/snippets" />
                            <PrivateRoute as={SongAdd} path="song-add" type="song" />
                            <PrivateRoute as={SongAdd} path="fact-add" type="fact" />
                            <PrivateRoute as={SongEdit} path="song-edit/:slug" />
                            <PrivateRoute as={SongEdit} path="fact-edit/:slug" />

                            {/* System pages */}
                            <NetworkError path="networkerror" />
                            <NotFound path="*" />
                        </Router>
                        </PageContainer>
                        
                    </div>
                    <div className="column is-1"></div>
                </div>
            </div>
            
      {/* <Footer /> */}
      </StoreProvider>
    </Fragment>
  );
}
